
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-hooks-use-graph-store-demo-xflow-hooks-use-graph-store"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.en.md?type=demo')
};